import React, { useState, useEffect } from "react";
import "./PageStyles.css";

const GamesPage = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedGame, setSelectedGame] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await fetch(`${apiUrl}/games`);
        if (!response.ok) {
          throw new Error("Failed to fetch games");
        }
        const data = await response.json();
        const parsed = Array.isArray(data) ? data : JSON.parse(data.body || "[]");
        setGames(parsed);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchGames();
  }, [apiUrl]);

  if (loading) {
    return (
      <div className="page-container">
        <h2>Educational Games</h2>
        <p className="loading-text">Loading games...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <h2>Educational Games</h2>
        <div className="message error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <h2>Educational Games</h2>
      <p>Select a game to play from the list below.</p>

      {selectedGame ? (
        <div className="game-player-container">
          <div className="game-player-header">
            <h3>{selectedGame.title}</h3>
            <button
              className="back-btn"
              onClick={() => setSelectedGame(null)}
            >
              ← Back to List
            </button>
          </div>
          <div className="game-iframe-wrapper">
            <iframe
              title={selectedGame.title}
              src={`${apiUrl}${selectedGame.content_url}`}
              sandbox="allow-scripts allow-same-origin"
              className="game-iframe"
            />
          </div>
        </div>
      ) : games.length === 0 ? (
        <p className="empty-text">No games available at the moment.</p>
      ) : (
        <div className="content-grid">
          {games.map((game) => (
            <div key={game.game_id} className="content-card">
              <h3>{game.title}</h3>
              <p className="content-date">
                Published: {new Date(game.date).toLocaleDateString()}
              </p>
              {game.description && (
                <p className="content-description">{game.description}</p>
              )}
              <button
                className="read-more-btn"
                onClick={() => setSelectedGame(game)}
              >
                Play Game ▶
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GamesPage;
